module.exports = __webpack_public_path__ + "static/media/Contact_Button@3x.4fcef58e.png";